/**
 * ToastContainer — renders the toast notification stack
 */
import { useState, useEffect } from 'react';

const ToastItem = ({ toast, onDismiss }) => {
  const [closing, setClosing] = useState(false);

  const handleDismiss = () => {
    setClosing(true);
    setTimeout(() => onDismiss(toast.id), 250);
  };

  // Listen for external dismissal (auto-timeout)
  useEffect(() => {
    if (toast.dismissing && !closing) {
      setClosing(true);
      setTimeout(() => onDismiss(toast.id), 250);
    }
  }, [toast.dismissing, closing, onDismiss, toast.id]);

  return (
    <div
      className={`toast toast--${toast.type}${closing ? ' toast--closing' : ''}`}
      role="status"
    >
      <span className="toast__message">{toast.message}</span>
      <div className="toast__actions">
        {toast.action && (
          <button
            className="toast__action-btn"
            onClick={() => {
              toast.action.onClick();
              handleDismiss();
            }}
          >
            {toast.action.label}
          </button>
        )}
        <button
          className="toast__dismiss"
          onClick={handleDismiss}
          aria-label="Dismiss"
        >
          &times;
        </button>
      </div>
    </div>
  );
};

const ToastContainer = ({ toasts, onDismiss }) => {
  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" aria-live="polite">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onDismiss={onDismiss} />
      ))}
    </div>
  );
};

export default ToastContainer;
